<style>
.edi-help {
	overflow: hidden;
}
.edi-help .foot ul {
	position: absolute;
	width: 100%;
	bottom: 0;
	margin: 0;
	padding: 0;
	background-color: #f8f8f8;
	border-top: 1px #d1d1d1 solid;
}
.edi-help-top {
	margin-top: 1em;
}
.edi-help .ui-listview,
.edi-help .ui-listview li {
	border: none;
	overflow: hidden;
}
.edi-help .ui-listview li > a {
	display: block;
	padding: .7em 1em;
}
.edi-help .ui-listview {
	margin-bottom: 1em;
}
.edi-help .head {
	border-bottom: 1px #cecece solid;
	position: relative;
}
.edi-help .head h4 {
	margin: 0;
	padding: .6em 1em;
	font-weight: normal;
}
.edi-help .head a {
	position: absolute;
	right: 0;
	top: 0;
	color: #656565;
	padding: .6em 1.6em .6em 1em;
}
.edi-help .ui-listview ul {
	margin: 0;
	padding: 0;
}
.edi-help .ui-listview ul li {
	float: left;
	width: 33.33%;
	text-align: center;
}
.edi-help .ui-listview ul i {
	width: 33px;
	height: 29px;
	display: block;
	margin: 0 auto 0.5em auto;
	background-size: 33px 29px;
}
.edi-help h4 {
	margin: 1em 0;
}
.edi-help p span,
.edi-help h4 span {
	display: inline-block;
	padding-left: 28px;
}
.edi-help p:before,
.edi-help h4:before {
	position: absolute;
	content: ' ';
	width: 20px;
	height: 20px;
	display: inline-block;
	background-size: 20px;
	margin-right: .5em;
	margin-top: .1em;
}
.edi-help h4:before {
	background-image: url('../assets/help/quest.png');
}
.edi-help p:before {
	background-image: url('../assets/help/answer.png');
}
.edi-help li {
	padding: 0 1em;
	line-height: 1.5em;
}
.edi-help .filter {
	background-color: #cbcbcb;
	padding: .4em .5em;
}
.edi-help .filter input {
	background-color: white;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.edi-help .container {
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
}
</style>

<template>
<div class="edi-help" :style="{ 'height': deviceHeight }">
	<!-- <div class="filter">
		<input type="text" placeholder="关键字搜索" class="ui-align-center"/>
	</div> -->
	<div class="container" :style="{ 'height': containerHeight }">
		<ul class="ui-listview edi-help-top order">
			<li>
				<h4><span>订单可以二次订货吗?</span></h4>
				<p><span>订单在发货后是不允许进行二次发货的，除非发货被拒绝，才可以进行发货处理。</span></p>
			</li>
		</ul>
		<ul class="ui-listview">
			<li>
				<h4><span>在接到订单时，第一步需做什么操作？</span></h4>
				<p><span>刚接到订单时，需进行是否同意单据操作，同意后方可进行编辑和发货处理。</span></p>
			</li>
		</ul>
		<ul class="ui-listview">
			<li>
				<h4><span>同一个账号是否可以在多台设备同时登录？</span></h4>
				<p><span>不可以。一个账号，同一时间只能在一台设备登录</span></p>
			</li>
		</ul>
	</div>
</div>
</template>
<!--{{{ script -->
<script>
export default {
	data () {
		return {
			deviceHeight: this.$root.deviceHeight,
			containerHeight: 'auto'
		}
	},
	mounted () {
		// var fh = this.$el.querySelector('.filter').offsetHeight
		// this.containerHeight = (parseInt(this.deviceHeight) - fh) + 'px'
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Help.vue?7930ebd0